var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('Header'),_c('v-layout',{staticClass:"fab-container",attrs:{"column":""}},[_c('ScrollTotop',{staticClass:"mx-4"}),_c('DarkTheme',{staticClass:"ma-4"})],1),_c('div',{staticStyle:{"height":"100%"},attrs:{"id":"content"}},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }